import definitions from "../../definitions";
import BossBatwitch from "./BossBatwitch";
import BossChick from "./BossChick";
import BossGnomeBear from "./BossGnomeBear";
import BossSpider from "./BossSpider";
import BossSuzie from "./BossSuzie";

export default class BossFactory {
    /**
     * @param {string} id
     * @param {object} [properties={}]
     * @returns {Boss}
     */
    static create(id, properties = {}) {
        switch (id) {
            case definitions.BOSS_ID.BATWITCH: {
                return new BossBatwitch();
            }
            case definitions.BOSS_ID.CHICK_OF_DOOM: {
                return new BossChick();
            }
            case definitions.BOSS_ID.GIANT_SPIDER: {
                return new BossSpider();
            }
            case definitions.BOSS_ID.GNOME_BEAR: {
                return new BossGnomeBear();
            }
            case definitions.BOSS_ID.SUZIE: {
                return new BossSuzie();
            }
        }
        return null;
    }
}